import { UserData } from 'contexts/session-context/session-reducer'
import { StartImg } from 'theme/start'
import { Back } from 'theme/theme'
import { Link } from 'react-router-dom'
import { GenericText } from 'views/memorama/views/list/styles/custom'
import { DescriptionText, SpanPolitics } from 'components/birthday-input/style.custom'
import { TitleAge } from 'components/legal-age/components/style/text'

const Arrow = ({ color }: { color?: string }) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 0.46875C12.3392 0.46875 14.0482 0.932617 15.627 1.86035C17.1569 2.75553 18.3695 3.9681 19.2646 5.49805C20.1924 7.07682 20.6562 8.78581 20.6562 10.625C20.6562 12.4642 20.1924 14.1732 19.2646 15.752C18.3695 17.2819 17.1569 18.4945 15.627 19.3896C14.0482 20.3174 12.3392 20.7812 10.5 20.7812C8.66081 20.7812 6.95182 20.3174 5.37305 19.3896C3.8431 18.4945 2.63053 17.2819 1.73535 15.752C0.807617 14.1732 0.34375 12.4642 0.34375 10.625C0.34375 8.78581 0.807617 7.07682 1.73535 5.49805C2.63053 3.9681 3.8431 2.75553 5.37305 1.86035C6.95182 0.932617 8.66081 0.46875 10.5 0.46875ZM10.5 2.03125C8.9375 2.03125 7.48893 2.42188 6.1543 3.20312C4.86849 3.9681 3.8431 4.99349 3.07812 6.2793C2.29688 7.61393 1.90625 9.0625 1.90625 10.625C1.90625 12.1875 2.29688 13.6361 3.07812 14.9707C3.8431 16.2565 4.86849 17.2819 6.1543 18.0469C7.48893 18.8281 8.9375 19.2188 10.5 19.2188C12.0625 19.2188 13.5111 18.8281 14.8457 18.0469C16.1315 17.2819 17.1569 16.2565 17.9219 14.9707C18.7031 13.6361 19.0938 12.1875 19.0938 10.625C19.0938 9.0625 18.7031 7.61393 17.9219 6.2793C17.1569 4.99349 16.1315 3.9681 14.8457 3.20312C13.5111 2.42188 12.0625 2.03125 10.5 2.03125ZM11.0615 5.62012L16.0664 10.625L11.0615 15.6299L9.93848 14.5312L13.0635 11.4062H5.03125V9.84375H13.0635L9.93848 6.71875L11.0615 5.62012Z"
        fill={color ?? '#DA2B1F'}
      />
    </svg>
  )
}

const ArrowWhite = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12.5" cy="12.5" r="9.5" fill="white" />
      <path
        d="M12.5 2.46875C14.3392 2.46875 16.0482 2.93262 17.627 3.86035C19.1569 4.75553 20.3695 5.9681 21.2646 7.49805C22.1924 9.07682 22.6562 10.7858 22.6562 12.625C22.6562 14.4642 22.1924 16.1732 21.2646 17.752C20.3695 19.2819 19.1569 20.4945 17.627 21.3896C16.0482 22.3174 14.3392 22.7812 12.5 22.7812C10.6608 22.7812 8.95182 22.3174 7.37305 21.3896C5.8431 20.4945 4.63053 19.2819 3.73535 17.752C2.80762 16.1732 2.34375 14.4642 2.34375 12.625C2.34375 10.7858 2.80762 9.07682 3.73535 7.49805C4.63053 5.9681 5.8431 4.75553 7.37305 3.86035C8.95182 2.93262 10.6608 2.46875 12.5 2.46875ZM12.5 4.03125C10.9375 4.03125 9.48893 4.42188 8.1543 5.20312C6.86849 5.9681 5.8431 6.99349 5.07812 8.2793C4.29688 9.61393 3.90625 11.0625 3.90625 12.625C3.90625 14.1875 4.29688 15.6361 5.07812 16.9707C5.8431 18.2565 6.86849 19.2819 8.1543 20.0469C9.48893 20.8281 10.9375 21.2188 12.5 21.2188C14.0625 21.2188 15.5111 20.8281 16.8457 20.0469C18.1315 19.2819 19.1569 18.2565 19.9219 16.9707C20.7031 15.6361 21.0938 14.1875 21.0938 12.625C21.0938 11.0625 20.7031 9.61393 19.9219 8.2793C19.1569 6.99349 18.1315 5.9681 16.8457 5.20312C15.5111 4.42188 14.0625 4.03125 12.5 4.03125ZM13.0615 7.62012L18.0664 12.625L13.0615 17.6299L11.9385 16.5312L15.0635 13.4062H7.03125V11.8438H15.0635L11.9385 8.71875L13.0615 7.62012Z"
        fill="#FF0000"
        fillOpacity="0.7"
      />
    </svg>
  )
}

export const languageES = {
  home: {
    title: <span className="text-black">¿Que quieres hacer?</span>,
    description: '¡COMPLETA TUS DATOS!',
    percentageProfile: 'Completo'
  },
  profile: {
    form: {
      information: {
        firstname: {
          label: '',
          placeholder: 'Pon tu nombre aquí'
        },
        lastname: {
          placeholder: 'Pon tu apellido aquí'
        },
        nickname: {
          label: (
            <>
              ¿apodo? <span className="font-normal">(OPCIONAL)</span>
            </>
          ),
          placeholder: '¿Cómo te gusta que te llamen?'
        },
        birthdate: {
          label: '¿fecha de nacimiento?'
        },
        gender: {
          label: '¿CÓMO TE IDENTIFICAS?'
        },
        email: {
          label: 'CORREO ELECTRÓNICO'
        }
      }
    },
    information: 'DATOS PERSONALES',
    informationEmail: 'EMAIL',
    address: '',
    contact: 'CONTACTO',
    button: 'MI TECATE ID',
    identification: {
      nav: 'MI TECATE ID',
      title: 'TECATE ID',
      button: 'DESCARGAR TECATE ID',
      label: 'Mi Tecate ID',
      name: 'TECATE ID'
    },
    stateNotFound: (
      <>
        No has canjeado ningún premio aún <br /> <b>¡venga, tú puedes!</b>
      </>
    ),
    view: {
      contact: {
        phoneTitle: ' ',
        emailTitle: 'Mail de contacto',
        emailTitle2: 'E-mail de contacto'
      }
    },
    state: 'MIS PREMIOS',
    stateLabel: 'Mis premios'
  },
  config: {
    prizes: '/profile/identificacion'
  },
  agegate: {
    title: <span className="invisible"></span>,
    description: (
      <div className="flex flex-col justify-between items-center gap-5 mx-7">
        <div className="flex flex-col items-center justify-center">
          <TitleAge>Te damos la bienvenida a</TitleAge>
          <img src={`${AZURE_BASE_URL}/logo-tecate-letras.svg`} alt="Titulo" />
        </div>
        <DescriptionText>
          Ingresa tu año de nacimiento, A MODO DE <br />
          validar tu mayoría de edad
        </DescriptionText>
        <img src={`${AZURE_BASE_URL}/Tecate-Arrows.png`} alt="Titulo" className="w-10" />
      </div>
    ),
    politics1: <span className="hidden"></span>,
    politics2: (
      <SpanPolitics>
        AL CONFIRMAR, ACEPTAS LA{' '}
        <a href={`${process.env.PUBLIC_URL}/privacy-politics`} rel="noreferrer" target="_blank" className="underline">
          POLÍTICA DE PRIVACIDAD
        </a>
        ,{' '}
        <a
          href={`${process.env.PUBLIC_URL}/terms-and-conditions`}
          rel="noreferrer"
          target="_blank"
          className="underline"
        >
          TÉRMINOS Y CONDICIONES Y USO DE COOKIES
        </a>{' '}
        DE ESTE SITIO WEB. ESTE SITIO WEB UTILIZA COOKIES. PARA OBTENER MÁS INFORMACIÓN, LEE NUESTRA POLÍTICA DE{' '}
        <a href={`${process.env.PUBLIC_URL}/privacy-politics`} rel="noreferrer" target="_blank" className="underline">
          PRIVACIDAD
        </a>{' '}
        Y USO DE{' '}
        <a
          href={`${process.env.PUBLIC_URL}/terms-and-conditions`}
          rel="noreferrer"
          target="_blank"
          className="underline"
        >
          COOKIES
        </a>
        .
      </SpanPolitics>
    )
  },
  legalage: {
    title: ''
  },
  start: {
    title: {
      html: (
        <Back className={`flex flex-col flex-1 w-full justify-center sm:items-center`}>
          <div className="w-full flex flex-1 flex-col text-lg  font-bold text-center gap-4 items-center justify-evenly">
            <StartImg src={`${AZURE_BASE_URL}/fondo-inicial.png`} alt="marca" className="px-10" />
          </div>
        </Back>
      )
    },
    signup: 'REGISTRARSE CON CORREO',
    signin: 'ENTRAR CON CORREO',
    xeerpa: {
      title: 'INGRESA A TU TECATE ID O CREA TU CUENTA PARA OBTENERLO'
    }
  },
  wifi: {
    buttonId: 'Quiero mi tecate id'
  },
  signup: {
    title: 'YA QUEDÓ, ',
    description:
      'Eres parte de Código Tecate, valida tu mail y checa tus correos para poder empezar a registrar tus códigos y ganar cosas chidas',
    welcome: {
      description: ' ',
      description3: (
        <>
          <b>¿No te llegó ningún mail?</b> <br /> Intentémoslo de nuevo
        </>
      ),
      'button-resend': 'Dá clic aquí para reenviarlo.'
    }
  },
  redeem: {
    subtitle: (
      <div className="flex justify-center items-center flex-col">
        <img src={`${AZURE_BASE_URL}/redeem-logo.png`} style={{ width: '70%' }} />
      </div>
    ),
    description: (
      <>
        Empieza a ganar águilas <br /> y llévate premios únicos
      </>
    ),
    description2: (
      <>
        ¿SABES ORAR? PUES ÓRALE, <br /> INGRESA TU CÓDIGO
      </>
    ),
    imageUrl: `${AZURE_BASE_URL}/redeem-welcome.png`
  },
  congrats: {
    title: 'VEEEEENGA ',
    description: (
      <div className="flex flex-col items-center justify-center text-center gap-3">
        <span>INGRESASTE 1 CÓDIGO NUEVO CON ÉXITO.</span>
        <span>
          LAS ÁGUILAS QUE SUMAS PARA
          <br /> CANJEARLAS POR COSAS CHIDAS
          <br /> SON:
        </span>
      </div>
    ),
    button1: 'MIRA LOS PREMIOS',
    range: {
      title: 'VEEEEEEENGA ',
      description2: (
        <>
          FELICITACIONES
          <br />
          HAS DESBLOQUEADO NUEVAS
          <br />
          COSAS EN CÓDIGO TECATE
        </>
      )
    }
  },
  prizes: {
    start: {
      title: 'Premios',
      card: {
        points: 'Águilas'
      },
      'not-found': 'Puedes ganar premios participando en nuestras dinámicas'
    },
    head: {
      title: <>TUS {POINTS_NAME?.toLowerCase()}:</>,
      description: '¿Ya pensaste en qué las canjearás?'
    },
    exchange: {
      title: 'PÉRATE, PÉRATE',
      information: {
        description: (
          <span style={{ fontSize: '10px' }}>*Es necesario que nos dejes estos datos para entregar tu premio</span>
        ),
        button: 'CONFIRMAR MIS DATOS',
        back: '¡VAMOS A ACTUALIZAR MIS DATOS!',
        confirm: {
          title: (
            <>
              ¡LISTO NAME! <br />{' '}
              <p
                className="text-base font-normal"
                style={{ fontFamily: 'Roboto', textTransform: 'none', lineHeight: '1.15rem' }}
              >
                Vamos a enviar tu premios considerando estos datos
              </p>
            </>
          ),
          button: 'CANJEAR',
          back: 'VOLVER'
        }
      },
      warning: '¿Segurísimo que quieres este premio?',
      textWarning: <>Estás a punto de canjear costInPoints pointsName por un prizeName.</>
    },
    congrats: {
      description: (
        <>
          <b>Tu premio ya va en camino.</b> <br /> Ponte al tiro con el mail que te haremos llegar, ahí vendrán los
          detalles de envío.
        </>
      ),
      title: 'Enhorabuena'
      // ¡Enhorabuena, Roberto!  Te quedan 3500 águilas, vamos por más.
    },
    arrow: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M19.0422 10.1411L9.85912 19.3242L8.22338 17.7172L14.6516 11.289L0.676025 11.289L0.676025 8.99323L14.6516 8.99323L8.22338 2.56507L9.85912 0.958023L19.0422 10.1411Z"
          fill="#DA2B1F"
        />
      </svg>
    ),
    description: {
      politic: (
        <>
          Para más información revisa nuestros <br />
          <Link to="/terms-and-conditions" className="underline">
            Términos y condiciones.
          </Link>
        </>
      )
    }
  },
  trivias: {
    questions2: 'preguntas sobre el tema y participa por:',
    prefpicker: {
      title: 'Primero cuentanos tus preferencias',
      description: 'selecciona al menos tres categorías'
    },
    congrats: '¡FELICITACIONES',
    triviaQr: {
      register: {
        title: (
          <>
            <span style={{ color: '#000000', fontFamily: 'Termina' }}>CONTESTA</span>
            <br />
            <span style={{ color: '#E1251B', fontFamily: 'Termina' }}>Y GANA</span>
          </>
        ),
        description: (
          <>
            <p>¿Ya tienes tu TECATE ID?</p>
            <p>
              SI NO CÓRRELE A <br />
              REGISTRARTE PARA <br />
              PODER PARTICIPAR
            </p>
          </>
        ),
        html: (
          <>
            <h1
              className="text-black font-bold text-center uppercase"
              style={{
                fontSize: '72px',
                fontFamily: 'HeadingProUltracomp',
                fontWeight: 700
              }}
            >
              <span style={{ color: '#E1251B' }}>CONTESTA </span>Y GANA
            </h1>
            <img src={`${AZURE_BASE_URL}/logo-positivo.svg`} alt="logo" className="px-16" />

            <p
              className="text-center font-bold text-black uppercase"
              style={{ fontSize: '32px', fontFamily: 'HeadingProUltracomp', lineHeight: '120%' }}
            >
              ¿Ya tienes tu TECATE ID?
            </p>

            <p
              className="text-center termina font-medium text-black uppercase"
              style={{ fontSize: '16px', fontFamily: 'Roboto' }}
            >
              SI NO CÓRRELE A REGISTRARTE PARA <br />
              PODER PARTICIPAR
            </p>
          </>
        )
      },
      late: {
        title: (user: UserData) => `¡QUE BUENO VERTE DE NUEVO ${user?.firstName.toUpperCase()}!`,
        description: (
          <span className="roboto">
            Lamentablemente esta trivia <br /> ya no está disponible.
          </span>
        )
      }
    },
    exit: {
      title: (
        <span
          className="text-center uppercase flex text-white "
          style={{
            fontWeight: 700,
            lineHeight: '100%',
            fontSize: '56px',
            fontFamily: 'HeadingProUltracomp'
          }}
        >
          ¿Estás seguro que <br /> quieres salir?
        </span>
      ),
      subtitle: (
        <span
          className="text-center flex text-white"
          style={{
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '20px'
          }}
        >
          Si cancelas ahora se perderá tu progreso y <br /> tendrás que volver a empezar.
        </span>
      ),
      accept: 'SI, CLARO',
      cancel: 'NO, VOLVER'
    },
    exchange: {
      title: 'FELICITACIONES',
      description: 'PARTICIPASTE POR',
      button: {
        text: 'VAMOS A COMPLETAR MIS DATOS',
        url: '/profile/information'
      }
    },
  },
  auctions: {
    current: 'Puedes seguir mirando las otras ofertas mientras se termina la que ya ofertaste.'
  },
  refferal: {
    title: 'Código de referido de Tecate',
    text1: '¡Hola! ¡Usa mi código ',
    text2: ' y obtén una chance diaria para ganar el futbolito y otros premios en la nueva dinámica de Tecate!'
  },
  referrals: {
    subtitle: 'Comparte tu código',
    description: 'Comparte tu código con amigos y suma más oportunidades de ganar.',
    // new referrals
    modal: {
      content: (
        <>
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/referrals-modal-icon-1.webp`} alt="icon" loading="lazy" />
            <p>
              <b>Completa los datos</b> termina de armar tu cuenta con tus datos personales.
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/referrals-modal-icon-2.webp`} alt="icon" loading="lazy" />
            <p>
              <b>Comparte tu código</b> invita a amigos a registrarse utilizando tu código referido y gana puntos extra por cada invitado que se una a la plataforma.
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/referrals-modal-icon-3.webp`} alt="icon" loading="lazy" />
            <p>
              <b>Participa por el premio especial</b> compartiendo tu código ganas más oportunidades de obtener los boletos a Tecate Pa’l Norte 2025. Recuerda hacer la trivia para estar participando.
            </p>
          </div>
        </>
      )
    },
    rules: {
      list: (
        <>
          <div className="w-full flex gap-5 justify-center">
            <Arrow />
            <div className="flex-1">
              <p className="font-normal roboto text-base">Regla 1.</p>
            </div>
          </div>
          <div className="w-full flex gap-5 justify-center">
            <Arrow />
            <div className="flex-1">
              <p className="font-normal roboto text-base">Regla 2.</p>
            </div>
          </div>
          <div className="w-full flex gap-5 justify-center">
            <Arrow />
            <div className="flex-1">
              <p className="font-normal roboto text-base">Regla 3.</p>
            </div>
          </div>
        </>
      )
    },
    code: {
      dynamic: {
        content: (
          <>
            <div className="referrals__code__dynamic__content__list-item">
              <Arrow color="white" />
              <div className="flex-1">
                <p className="">
                  Tienes que haber realizado la <b>trivia de Tecate Pa’l Norte</b> para participar por los boletos.
                </p>
              </div>
            </div>
            <div className="referrals__code__dynamic__content__list-item">
              <Arrow color="white" />
              <div className="flex-1">
                <p className="">
                  Cada amigo que refieras y se registre <b>suma una oportunidad más</b> para ganar los boletos a Tecate Pa’l Norte 2025.
                </p>
              </div>
            </div>
          </>
        )
      }
    }
  },
  error: {
    505: {
      title: <span className="uppercase text-white text-center">¡oh no!</span>,
      description: (
        <span className="uppercase text-white text-center font-normal">
          <b>FALLASTE</b>
          <p>PUEDES VOLVER A INTENTAR</p>
        </span>
      ),
      button: {
        text: 'VUELVE A INTENTARLO',
        link: '/trivias'
      }
    },
    10: {
      title: (
        <>
          ¡Ups! El código <br /> QUE INGRESASTE ES <br /> INVÁLIDO{' '}
        </>
      )
    },
    50: {
      title: 'TU CUENTA AÚN NO FUE VALIDADA',
      description: 'Te hemos enviado un mail para avanzar.'
    },
    1116: {
      description:
        'Lo sentimos, no es posible cargar en tan corto tiempo tus contenidos, te esperamos de vuelta más tarde.',
      button: {
        text: 'Volver',
        link: 'album/redirect/Card/upload'
      }
    },
    1114: {
      title: 'No hemos podido validar tu imagen',
      description: 'Tu imagen ha sido rechazada por:'
    },
    860: {
      title: 'YA HAS COMPLETADO ESTA ENCUESTA',
      description: 'Lamentablemente esta encuesta ya no está disponible. Estate atento para contestar una nueva.'
    }
  },
  tivias: {
    challenge: {
      modal: {
        intro2: 'Estás a punto de participar en esta trivia por:',
        back: <span className="text-white underline">NO, VOLVER</span>
      }
    }
  },
  memorama: {
    list: {
      title: 'MEMORAMA',
      'not-found': 'No hay dinámicas disponibles por el momento, estate atento a las nuevas que tendremos próximamente.'
    },
    participate: {
      register: {
        title: (
          <>
            <span style={{ color: '#000000', fontFamily: 'Termina' }}>PARTICIPA</span>
            <br />
            <span style={{ color: '#E1251B', fontFamily: 'Termina' }}>Y GANA</span>
          </>
        ),
        description: (
          <>
            <p>¿Ya tienes tu TECATE ID?</p>
            <p>
              SI NO CÓRRELE A <br />
              REGISTRARTE PARA <br />
              PODER PARTICIPAR
            </p>
          </>
        ),
        html: (
          <>
            <h1
              className="text-black font-bold text-center uppercase"
              style={{
                fontSize: '72px',
                fontFamily: 'HeadingProUltracomp',
                fontWeight: 700
              }}
            >
              <span style={{ color: '#E1251B' }}>PARTICIPA </span>Y GANA
            </h1>
            <img src={`${AZURE_BASE_URL}/logo-positivo.svg`} alt="logo" className="px-16" />

            <p
              className="text-center font-bold text-black uppercase"
              style={{ fontSize: '32px', fontFamily: 'HeadingProUltracomp', lineHeight: '120%' }}
            >
              ¿Ya tienes tu TECATE ID?
            </p>

            <p
              className="text-center termina font-medium text-black uppercase"
              style={{ fontSize: '16px', fontFamily: 'Roboto' }}
            >
              SI NO CÓRRELE A REGISTRARTE PARA <br />
              PODER PARTICIPAR
            </p>
          </>
        )
      },
    },
    modal: {
      title: (
        <>
          MEMORAMA
          <br />
          <span style={{ fontSize: '32px', color: '#CF202F' }}>INSTRUCCIONES</span>
        </>
      ),
      items: (
        <div className="flex-1">
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-1.svg`} alt="icons" />
            <GenericText className="flex-1">
              <b>Concéntrate y memoriza</b> el orden de las imágenes que van a aparecer.
            </GenericText>
          </div>
          <div className="flex gap-4 mt-10 items-center">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-2.svg`} alt="icons" />
            <GenericText className="flex-1">
              <b>Estas desaparecerán</b> y debes recordar el lugar donde estaban.
            </GenericText>
          </div>
          <div className="flex gap-4 mt-10 items-center">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-3.svg`} alt="icons" />
            <GenericText className="flex-1">
              <b>Si aciertas en todas, ¡GANAS!</b>
            </GenericText>
          </div>
          <div className="flex gap-4 mt-10 items-center">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-4.svg`} alt="icons" />
            <GenericText className="flex-1" style={{ color: '#DA2B1F' }}>
              <b>Atención:</b> solo podrán participar aquellos residentes que vivan en el mismo estado donde se llevará
              a cabo el partido.
            </GenericText>
          </div>
        </div>
      ),
      play: {
        description: 'Estás a punto de participar en este memorama y ganar:',
        warning: '¿Seguro que quieres empezar a jugar? Una vez que des clic no hay vuelta atrás.'
      }
    },
    exchange: {
      button: {
        text: 'Completar mis datos'
      }
    },
    exit: {
      accept: 'SI, CLARO',
      cancel: 'NO, VOLVER'
    }
  },
  album: {
    title: 'RETOS',
    states: {
      all: 'TODOS',
      progress: 'ACTUALES',
      completed: 'PASADOS'
    },
    notFound: 'No hay retos disponibles por el momento, estate atento a nuestras nuevas dinámicas.',
    register: {
      title: (
        <>
          <span style={{ color: '#000000', fontFamily: 'Termina' }}>CONTESTA</span>
          <br />
          <span style={{ color: '#E1251B', fontFamily: 'Termina' }}>Y GANA</span>
        </>
      ),
      description: (
        <>
          <p>¿Ya tienes tu TECATE ID?</p>
          <p>
            SI NO CÓRRELE A <br />
            REGISTRARTE PARA <br />
            PODER PARTICIPAR
          </p>
        </>
      ),
      html: (
        <>
          <h1
            className="text-black font-bold text-center uppercase"
            style={{
              fontSize: '72px',
              fontFamily: 'HeadingProUltracomp',
              fontWeight: 700
            }}
          >
            <span style={{ color: '#E1251B' }}>CONTESTA </span>Y GANA
          </h1>
          <img src={`${AZURE_BASE_URL}/logo-positivo.svg`} alt="logo" className="px-16" />

          <p
            className="text-center font-bold text-black uppercase"
            style={{ fontSize: '32px', fontFamily: 'HeadingProUltracomp', lineHeight: '120%' }}
          >
            ¿Ya tienes tu TECATE ID?
          </p>

          <p
            className="text-center termina font-medium text-black uppercase"
            style={{ fontSize: '16px', fontFamily: 'Roboto' }}
          >
            SI NO CÓRRELE A REGISTRARTE PARA <br />
            PODER PARTICIPAR
          </p>
        </>
      ),
      button: 'COMENCEMOS'
    }
  },
  social: {
    Consumo: {
      congrats: {
        description: (
          <>
            OBTUVISTE <b>VAR_POINTS ÁGUILAS</b>
          </>
        ),
        button1: 'VER LOS PREMIOS',
        button2Link: '/album/redirect/Consumo/upload',
        button2: 'CARGAR OTRA IMAGEN'
      },
      howToParticipate: {
        subtitle: 'SUBE TU FOTO Y PARTICIPA',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7">
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-1.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="text-lg font-normal roboto leading-6" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Completa los datos</b> personales de perfil en tu cuenta.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-2.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-normal text-lg roboto leading-6" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Sube una foto</b> de tu cerveza en botella y genera ÁGUILAS con cada imagen que subas.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-3.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-normal text-lg roboto leading-6" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Acumula Águilas</b> y canjéalos por premios o merch en la vitrina.
                </p>
              </div>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No subir contenido inapropiado.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    No debe aparecer la marca en un entorno de exceso, peligro o violencia.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No aparecer con menores de edad.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No deben aparecer otras marcas de cerveza.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    Si se realiza más de una publicación que no va con las reglas se inactivará el usuario para que no
                    pueda subir más contenido.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    Puedes subir como máximo 3 fotos de consumos consecutivos cada 24hrs.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    Puede subir contenido cada 15 minutos acumulativos, es decir a los 15 min, 30 min y 45 min.
                  </p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        title: 'Cargar foto',
        subtitle: 'Clic para subir una foto',
        rules: {
          title: 'REGLAS PARA SUBIR CONTENIDO',
          list: (
            <ul style={{ color: '#15141A', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Usa la cámara de tu celular para tomarle una foto a tu cerveza.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Busca un lugar iluminado para tomar la foto.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> Mantente quieto al momento de tomar la foto para obtener una imagen de buena calidad.
                </p>
              </li>
            </ul>
          )
        },
        errorModalValidate: {
          description: 'Aún no puedes subir nuevo contenido por las siguientes razones:',
          list: (
            <div style={{ width: '320px' }}>
              <div style={{ color: 'white' }} className="Montserrat text-sm font-normal">
                <p className="ml-5 mb-3">
                  {' '}
                  • Llegaste al máximo de contenido que puedes cargar en el día. (puedes subir máx. 3 por día)
                </p>
                <p className="ml-5 mb-3">
                  {' '}
                  • Llegaste al máximo de contenido que puedes cargar en total. (puedes subir máx. 15 imágenes)
                </p>
                <p className="ml-5">
                  {' '}
                  • Aún no pasaron los 30 min. desde que subiste tu segunda foto. (Son 15 minutos acumulativos desde que
                  subes tu primer imagen).
                </p>
              </div>
            </div>
          ),
          help: (
            <div
              style={{ width: '320px', color: 'white' }}
              className="flex justify-center items-center flex-col mb-12 Montserrat pt-4"
            >
              <span className="font-bold text-center text-sm Montserrat">¿Te parece que no es así?</span>
              <span className="text-center text-sm Montserrat">
                Ponte en contacto con nosotros para que <br /> podamos ayudarte.{' '}
                <Link to="/help" className="underline">
                  Envíanos un mensaje.
                </Link>{' '}
              </span>
            </div>
          )
        },
        icon: (
          <svg width="80" height="84" viewBox="0 0 80 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
          </svg>
        ),
        howToTakePhoto: {
          title: 'IMAGEN DE REFERENCIA',
          subtitle: 'CONSEJOS PARA TOMAR UNA FOTO CORRECTA',
          'how-take-photo-list': (
            <ul style={{ padding: 'revert', listStyle: 'disc' }}>
              <li className="text-white pb-5">
                Intenta sacar la foto con buena iluminación y sobre un fondo lo más limpio y plano posible (que no tenga
                muchos objetos de fondo)
              </li>
              <li className="text-white pb-5">
                Procura que el logo de TECATE se vea lo mejor y más completo posible, que se lea TECATE y se vea el
                águila.
              </li>
              <li className="text-white">
                Intenta que la foto salga nítida, clara y bien enfocada. Que la botella o lata esté centrada y no haya
                otros elementos.
              </li>
            </ul>
          )
        },
        isReady: '¿Está ok esta FOTO?'
      }
    },
    Card: {
      howToParticipate: {
        subtitle: 'Crea tu frase y compártela',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7">
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/cuenta_icon.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="text-base font-normal roboto leading-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000' }}
                >
                  <b>Completa tus datos</b> personales en el perfil de tu cuenta.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/cargar-frase_icon.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="font-normal text-base roboto leading-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000' }}
                >
                  <b>Completa la frase</b> con tus propias palabras y crea tu pieza original para participar por los
                  premios.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/compartir_icon.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="font-normal text-base roboto leading-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000' }}
                >
                  <b>Comparte tu nueva creación</b> con tus amigos para que vean lo creativo que eres.
                </p>
              </div>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No subir contenido inapropiado.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No nombrar otras marcas de cerveza.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    Si el contenido subido es considerado inapropiado, la plataforma no generará la imagen y se le
                    comunicará al usuario los motivos por los cuales no se generó.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    Se permite subir hasta tres frases en total, con una sola posibilidad de ganar.
                  </p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        title: 'Cargar foto',
        subtitle: 'Clic para subir una foto',
        rules: {
          title: 'REGLAS PARA SUBIR CONTENIDO',
          list: (
            <ul style={{ color: '#15141A', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Completa la frase de la imagen con lo que te parezca que vaya mejor.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Tiene que ser en muy pocas palabras.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> Revisa como queda la imagen final para aprobarla o volver a hacerlo.
                </p>
              </li>
            </ul>
          )
        },
        errorModalValidate: {
          description: 'Aún no puedes subir nuevo contenido por la siguiente razón:',
          list: (
            <div style={{ width: '320px' }}>
              <div style={{ color: 'white' }} className="Montserrat text-sm font-normal">
                <p className="ml-5 mb-3">
                  {' '}
                  • Llegaste al máximo de contenido que puedes cargar en total. (puedes cargar máx. 3 imágenes)
                </p>
              </div>
            </div>
          ),
          help: (
            <div
              style={{ width: '320px', color: 'white' }}
              className="flex justify-center items-center flex-col mb-12 Montserrat pt-4"
            >
              <span className="font-bold text-center text-sm Montserrat">¿Te parece que no es así?</span>
              <span className="text-center text-sm Montserrat">
                Ponte en contacto con nosotros para que <br /> podamos ayudarte.{' '}
                <Link to="/help" className="underline">
                  Envíanos un mensaje.
                </Link>{' '}
              </span>
            </div>
          )
        },
        icon: (
          <svg width="80" height="84" viewBox="0 0 80 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
          </svg>
        ),
        isReady: '¿Está ok esta imagen?',
        'ranking-subtitle': {
          progress: 'En esta galería puedes ver todas las imágenes creadas por los participantes.',
          completed: 'Aquí puedes ver las frases ganadores del reto.'
        },
        alreadyUploaded: {
          icon: (
            <>
              <svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="62.084" cy="62.084" r="60.084" stroke="#FFCC71" strokeWidth="4" />
                <path d="M26 56L55 85L98 42" stroke="#FFCC71" strokeWidth="6" strokeLinecap="square" />
              </svg>
            </>
          ),
          description: 'Se ha agregado correctamente tu contenido.',
          button: {
            url: '/album/redirect/Card/profile',
            text: 'Ver mi contenido'
          },
          button2: {
            url: '/album/redirect/Card/ranking',
            text: 'Ver galería'
          },
          buttonBack: {
            text: 'CARGAR OTRA IMAGEN'
          }
        },
        howToTakePhoto: {
          'how-take-photo-list': (
            <ul style={{ padding: 'revert', listStyle: 'disc' }}>
              <li className="text-white pb-5">
                Intenta sacar la foto con buena iluminación y sobre un fondo lo más limpio y plano posible (que no tenga
                muchos objetos de fondo)
              </li>
              <li className="text-white pb-5">
                Procura que el logo de TECATE se vea lo mejor y más completo posible, que se lea TECATE y se vea el
                águila.
              </li>
              <li className="text-white">
                Intenta que la foto salga nítida, clara y bien enfocada. Que la botella o lata esté centrada y no haya
                otros elementos.
              </li>
            </ul>
          )
        }
      },
      profile: {
        button: {
          text: 'Agregar nueva imagen'
        },
        return: {
          url: '/album/:id/ranking',
          text: 'VER GALERÍA'
        },
        shared: {
          text: 'El calor pide este kit y tu...',
          url: `${URL_BASE}${process.env.PUBLIC_URL}/album/redirect/Card/ranking`
        },
        title: 'Mi contenido'
      },
      maxLength: 36
    },
    Ticket: {
      howToParticipate: {
        subtitle: 'SUBE TUS TICKETS Y GANA',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7 mt-3">
            <li className="flex flex-row w-full gap-4 items-start">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-10.svg`} className='w-12' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="text-lg font-normal roboto leading-5" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Completa tus datos</b> personales en el perfil de tu cuenta.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-4 items-start">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-11.svg`} className='w-12' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-normal text-lg roboto leading-5" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Sube una foto de tu ticket</b> donde se vea bien el detalle de tu compra de productos Tecate Original o Light en Lata de 355ml.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-4 items-start">
              <img src={`${AZURE_BASE_URL}/icono-tickets.webp`} className='w-12' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-normal text-lg roboto leading-5" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Acumula recibos y participa en el ranking</b><br />Mientras más tickets subas más oportunidades de ganar tienes.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-4 items-start">
              <img src={`${AZURE_BASE_URL}/icono-six.webp`} className='w-12' />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="font-normal text-base roboto leading-5"
                  style={{ fontFamily: 'Roboto', color: '#DA2B1F' }}
                >
                  <b>Atención:</b> Solo podrán participar en el ranking los tickets provenientes de <b>Tienda SIX</b> con latas de Tecate Original o Light de 355ml.
                </p>
              </div>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    El ticket debe tener productos Tecate Original o Light en presentación lata de 355mL.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">El ticket debe provenir de una <b>Tienda SIX</b>.</p>
                </div>
              </div>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">Se debe visualizar la fecha de compra.</p>
                </div>
              </div>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No se debe cargar un ticket repetido.</p>
                </div>
              </div>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">Puedes subir como máximo cinco tickets por día.</p>
                </div>
              </div>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">Los ganadores serán aquellos que al final de la dinámica, hayan cargado la mayor cantidad de tickets.</p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        title: 'Cargar RECIBO',
        subtitle: 'Clic para subir tu recibo',
        rules: {
          title: 'REGLAS PARA SUBIR TUS TICKETS',
          list: (
            <ul style={{ color: '#15141A', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Usa la cámara de tu celular para tomarle una foto al ticket para luego subirla aquí.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Busca un lugar iluminado para tomar la foto. Mantente quieto al momento de tomar la foto para obtener una imagen de buena calidad.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span><span>El ticket tiene que ser de una <b>Tienda SIX</b> y de productos Tecate Original y/o Light en latas de 355ml.</span>
                </p>
              </li>
            </ul>
          )
        },
        errorModalValidate: {
          description: 'Aún no puedes subir nuevo contenido por las siguientes razones:',
          list: (
            <div style={{ width: '320px' }}>
              <div style={{ color: 'white' }} className="Montserrat text-sm font-normal">
                <p className="ml-5 mb-3">• Llegaste al máximo de contenido que puedes cargar en el día. (puedes subir máx. 5 por día)</p>
                <p className="ml-5 mb-3">• Aún no pasaron los 30 min. desde que subiste tu segunda foto. (Son 15 minutos acumulativos desde que subes tu primer imagen).</p>
              </div>
            </div>
          ),
          help: (
            <div
              style={{ width: '320px', color: 'white' }}
              className="flex justify-center items-center flex-col mb-12 Montserrat pt-4"
            >
              <span className="font-bold text-center text-sm Montserrat">¿Te parece que no es así?</span>
              <span className="text-center text-sm Montserrat">
                Ponte en contacto con nosotros para que <br /> podamos ayudarte.{' '}
                <Link to="/help" className="underline">
                  Envíanos un mensaje.
                </Link>{' '}
              </span>
            </div>
          )
        },
        icon: (
          <svg width="80" height="84" viewBox="0 0 80 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.8002" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
            <rect
              x="11.2036"
              y="43.019"
              width="3.23774"
              height="56.7742"
              transform="rotate(-90 11.2036 43.019)"
              fill="#DA2B1F"
            />
          </svg>
        ),
        isReady: 'Seleccionar imagen',
        buttonSubmit: 'ELEGIR Y CONTINUAR',
        'ranking-subtitle': {
          progress: 'En esta galería puedes ver todas las imágenes creadas por los participantes.',
          completed: 'Aquí puedes ver las frases ganadores del reto.'
        },
        howToTakePhoto: {
          title: 'IMAGEN DE REFERENCIA',
          subtitle: 'CONSEJOS PARA TOMAR UNA FOTO CORRECTA',
          'how-take-photo-img': 'takePhotoImgModelTicket.webp',
          'how-take-photo-list': (
            <ul style={{ padding: 'revert', listStyle: 'disc' }}>
              <li className="text-white pb-2">Busca un lugar bien iluminado para tomar la foto del ticket.</li>
              <li className="text-white pb-2">Ubica el recibo sobre alguna superficie plana y déjalo lo más estirado y recto que puedas. Si es posible toma la foto sobre un fondo limpio y sin otros elementos.</li>
              <li className="text-white pb-2">Asegúrate que se vean bien los artículos, la fecha y el lugar de compra.</li>
              <li className="text-white">Recuerda que el ticket tiene que ser de una <b>Tienda SIX</b> y de productos Tecate Original y/o Light en latas de 355ml.</li>
            </ul>
          )
        },
      },
      congrats: {
        title: 'ESO ',
        description: "Sigue  subiendo tus tickets y sube tu posición en el ranking.",
        button1: 'CARGAR OTRO TICKET',
        button2: 'IR A VER EL RANKING',
        button2Link: '/ranking'
      },
      config: {
        prizes: '/album/redirect/Ticket/upload'
      }
    },
    Foto: {
      howToParticipate: {
        subtitle: 'Sube tu foto y participa',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7 mt-3">
            <li className="flex flex-row w-full gap-4 items-start">
              <img src={`${AZURE_BASE_URL}/foto-howToParticipate-1.svg`} className='w-12' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="text-lg font-normal roboto leading-5" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Tomate una foto en el photo opportunity</b> con la mayor cantidad de amigos/personas que puedas.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-4 items-start">
              <img src={`${AZURE_BASE_URL}/foto-howToParticipate-2.svg`} className='w-12' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-normal text-lg roboto leading-5" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Carga la foto</b> que tomaste para participar por el premio. Ganará quien suba la foto con más personas en la imagen.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-4 items-start">
              <img src={`${AZURE_BASE_URL}/foto-howToParticipate-3.svg`} className='w-12' />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-normal text-lg roboto leading-5" style={{ fontFamily: 'Roboto', color: '#000000' }}>
                  <b>Completa los datos</b> personales de perfil en tu cuenta.
                </p>
              </div>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">
                    No subir contenido inapropiado.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No debe aparecer la marca en un entorno de exceso, peligro o violencia.</p>
                </div>
              </div>
              <div className="w-full flex gap-2 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal roboto text-base">No aparecer con menores de edad.</p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        title: 'Cargar Foto',
        subtitle: 'Clic para cargar una foto',
        rules: {
          title: 'CONSEJOS PARA TOMAR LA FOTO',
          list: (
            <ul style={{ color: '#15141A', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Usa la cámara de tu celular para tomar la foto y luego cárgala desde tu dispositivo.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Asegúrate de tomar la foto dentro del stand.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span><span>Acomoda a tus acompañantes para que entren todos en la imagen y que estén todos mirando a la cámara.</span>
                </p>
              </li>
            </ul>
          )
        },
        errorModalValidate: {
          description: 'Aún no puedes subir nuevo contenido',
          list: (
            <div style={{ width: '320px' }}>
            </div>
          ),
          help: (
            <div
              style={{ width: '320px', color: 'white' }}
              className="flex justify-center items-center flex-col mb-12 Montserrat pt-4"
            >
              <span className="font-bold text-center text-sm Montserrat">¿Te parece que no es así?</span>
              <span className="text-center text-sm Montserrat">
                Ponte en contacto con nosotros para que <br /> podamos ayudarte.{' '}
                <Link to="/help" className="underline">
                  Envíanos un mensaje.
                </Link>{' '}
              </span>
            </div>
          )
        },
        icon: (
          <svg width="80" height="84" viewBox="0 0 80 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="37.9841" y="12.48" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.48" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="37.9841" y="12.48" width="3.21363" height="57.2" fill="#DA2B1F" />
            <rect x="11.2036" y="42.6992" width="3.23774" height="56.7742" transform="rotate(-90 11.2036 42.6992)" fill="#DA2B1F" />
            <rect x="11.2036" y="42.6992" width="3.23774" height="56.7742" transform="rotate(-90 11.2036 42.6992)" fill="#DA2B1F" />
            <rect x="11.2036" y="42.6992" width="3.23774" height="56.7742" transform="rotate(-90 11.2036 42.6992)" fill="#DA2B1F" />
          </svg>
        ),
        isReady: '¿Está ok esta FOTO?',
        buttonSubmit: 'Si, añadir',
      },
      congrats: {
        title: 'VEEEEENGA ',
        description: <>OBTUVISTE VAR_TITLE</>,
        button1: 'COMPLETAR DATOS',
        button1Link: '/profile',
        button2: 'IR A VER EL RANKING',
        button2Link: '/ranking'
      },
      config: {
        prizes: '/album/redirect/Ticket/upload'
      }
    },
  },
  ranking: {
    dynamic: {
      url: '/album/redirect/Ticket/upload',
      text: 'Participar'
    },
    description: 'Este es el ranking con los participantes que más puntos consiguieron cargando sus tickets. Si aún no cargaste el tuyo, usa el botón y participa.',
    position: {
      points: <>
        <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.5 1.02221L1.5 1L2.18406 1.74988L1 3.58321V17.6665L2.77119 18.9999H10.5085L12 17.6665V3.58321L10.8814 1.74988L11.5 1.02221Z" stroke="#747474" strokeLinejoin="round" />
          <path d="M10 4L10 15.1716C10 15.702 9.78929 16.2107 9.41421 16.5858L9 17" stroke="#747474" />
        </svg>
      </>
    },
    item: {
      points: <>
        <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.5 1.02221L1.5 1L2.18406 1.74988L1 3.58321V17.6665L2.77119 18.9999H10.5085L12 17.6665V3.58321L10.8814 1.74988L11.5 1.02221Z" stroke="black" strokeLinejoin="round" />
          <path d="M10 4L10 15.1716C10 15.702 9.78929 16.2107 9.41421 16.5858L9 17" stroke="black" />
        </svg>
      </>
    }
  },
  endroute: {
    title: (
      <>
        ¡Lo sentimos! <br />
        Esto es solo para <br />
        mayores
      </>
    ),
    description: 'Vuelve cuando seas más grande.'
  },
  header: {
    points: {
      br: (
        <>
          <br />
        </>
      )
    }
  },
  mail: {
    title: <>¡Excelente, name!</>
  },
  update: {
    street: {
      subtitle: (
        <>
          Si es correcto, completa los últimos datos <br /> y dale a actualizar.
        </>
      )
    }
  },
  password: {
    title: 'Resetear',
    label: {
      newPassword: 'NUEVA Contraseña',
      newPasswordConfirm: 'Confirmar Contraseña'
    }
  },
  wheelFortune: {
    rules: (
      <>
        <div className="w-full flex gap-5 justify-center">
          <Arrow />
          <div className="flex-1">
            <p className="font-normal roboto text-base">
              Para obtener chances de girar la rueda tienes que completar alguna actividad de la plataforma.
            </p>
          </div>
        </div>
        <div className="w-full flex gap-5 justify-center">
          <Arrow />
          <div className="flex-1">
            <p className="font-normal roboto text-base">
              Obtendrás 1 chance de girar la rueda por cada dinámica o actividad que completes exitosamente.
            </p>
          </div>
        </div>
        <div className="w-full flex gap-5 justify-center">
          <Arrow />
          <div className="flex-1">
            <p className="font-normal roboto text-base">
              Podrás obtener 1 chance cómo máximo de cada actividad por día.
            </p>
          </div>
        </div>
      </>
    )
  },
  wheel: {
    congrats: {
      win: {
        button: {
          text: "Volver AL HOME",
          url: "/home"
        }
      },
      lose: {
        button: {
          text: "Volver AL HOME"
        }
      }
    }
  },
  login: {
    exchange: {
      button: {
        text: 'Continuar'
      }
    }
  },
  events: {
    map: {
      onboarding: {
        list: (
          <>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal roboto text-base">
                  Para empezar, necesitaremos que nos des permisos para acceder a tu ubicación, esto nos ayudará a
                  brindarte una mejor experiencia usando el mapa.
                </p>
              </div>
            </div>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal roboto text-base">
                  Podrás usar el mapa para ubicar puntos de interés dentro del campo del evento.
                </p>
              </div>
            </div>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal roboto text-base">
                  Utiliza la ubicación para pinnear en el parking tu coche.
                </p>
              </div>
            </div>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal roboto text-base">
                  Si no dispones de internet, podrás descargarlo en formato imagen con todos los puntos de interés.
                </p>
              </div>
            </div>
          </>
        )
      }
    }
  },
  groups: {
    start: {
      onboarding: {
        list: (
          <>
            <img src={`${AZURE_BASE_URL}/groups-header.png`} />
            <ul className="flex-1 items-center justify-center flex-col flex w-full gap-6 pb-7">
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-2.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p
                    className="text-lg font-normal roboto leading-6"
                    style={{ fontFamily: 'Roboto', color: '#000000' }}
                  >
                    <b>Crea un grupo o sé parte de uno</b>
                    <br />
                    Forma tu propio grupo, dale un nombre y un perfil para empezar. También puedes participar formando
                    parte de un grupo al que te inviten.
                  </p>
                </div>
              </li>
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-1.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p
                    className="font-normal text-lg roboto leading-6"
                    style={{ fontFamily: 'Roboto', color: '#000000' }}
                  >
                    <b>Invita a tus amigos y acumula puntos</b>
                    <br />
                    Invita a tus amigos a formar parte de tu grupo y empiecen a juntar puntos participando de dinámicas.
                  </p>
                </div>
              </li>
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-3.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p
                    className="font-normal text-lg roboto leading-6"
                    style={{ fontFamily: 'Roboto', color: '#000000' }}
                  >
                    <b>Participa por el premio especial</b>
                    <br />
                    Al terminar la “temporada” ganará el grupo que haya acumulado la mayor cantidad de puntos en las
                    distintas.
                  </p>
                </div>
              </li>
            </ul>
          </>
        )
      }
    }
  },
  survey: {
    onboarding: {
      html: (
        <div className='w-full px-7 space-y-3 flex items-center flex-col' style={{ color: 'black' }}>
          <h3 className='title big text-center'><span style={{ color: '#DA2B1F' }}>CONTESTA</span> Y GANA</h3>
          <img src={`${AZURE_BASE_URL}/qr-not-user-id-v2.webp`} alt="card id" style={{ width: '70%' }} />
          <p className='title small text-center'>¿YA TIENES TU TECATE ID?</p>
          <p className='text big text-center'>SI NO, CÓRRELE A REGISTRARTE PARA PODER PARTICIPAR</p>
        </div>
      )
    },
    button: 'SIGUIENTE',
    title: {
      16: <>
        ENCUESTA FÚTBOL
        <img src={`${AZURE_BASE_URL}/futbol-encuesta-encabezado-liga.webp`} alt="encuesta futbol" className='w-full' />
      </>
    },
    exchange: {
      title: {
        16: '¡Gracias por participar!'
      },
      description: {
        16: 'Espera novedades para ganar la experiencia VIP.'
      }
    }
  },
  checkpoint: {
    prize: {
      button: 'COMPLETAR DATOS',
      buttonUrl: '/profile'
    },
    onboarding: {
      html: (
        <div className='w-full px-7 space-y-3 flex items-center flex-col' style={{ color: 'black' }}>
          <h3 className='title big text-center'><span style={{ color: '#DA2B1F' }}>ESCANEA</span> Y GANA</h3>
          <img src={`${AZURE_BASE_URL}/qr-not-user-id.webp`} alt="card id" />
          <p className='title small text-center'>¿YA TIENES TU TECATE ID?</p>
          <p className='text big text-center'>SI NO, CÓRRELE A REGISTRARTE PARA PODER PARTICIPAR</p>
        </div>
      )
    }
  }
}
